import { CoreIcon } from '../core-icon';
import bankLinepaySVG from '../../assets/logos/bank-linepay.svg';
import type { IconProps } from '../core-icon';

export const BankLinepayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankLinepaySVG} {...props} />;
};
